var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61539 8.80772C1.61539 5.90676 1.61539 4.45629 2.5166 3.55508C3.41781 2.65387 4.86828 2.65387 7.76923 2.65387H10.8462C13.7471 2.65387 15.1976 2.65387 16.0988 3.55508C17 4.45629 17 5.90676 17 8.80772V10.3462C17 13.2471 17 14.6976 16.0988 15.5988C15.1976 16.5 13.7471 16.5 10.8462 16.5H7.76923C4.86828 16.5 3.41781 16.5 2.5166 15.5988C1.61539 14.6976 1.61539 13.2471 1.61539 10.3462V8.80772Z",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46154 2.65385V1.5",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1539 2.65385V1.5",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.5H16.6154",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b9354941dab8425f1441171016f5950a.svg";
export { ForwardRef as ReactComponent };